import DisplayFieldText from '../display-field-text/display-field-text.vue';
import { Component } from 'vue-property-decorator';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';
import DisplayFieldPrice from '../display-field-price/display-field-price.vue';
import DisplayFieldPercent from '../display-field-percent/display-field-percent.vue';

const DisplayFieldLink = () => import('../display-field-link/display-field-link.vue');
const DisplayContactLink = () => import('../display-contact-link/display-contact-link.vue');
const DisplayFieldTppwbSync = () =>
  import('../display-field-tppwb-sync/display-field-tppwb-sync.vue');
const DisplayFieldIcon = () => import('../display-field-icon/display-field-icon.vue');
const DisplayFieldBadge = () => import('../display-field-badge/display-field-badge.vue');
const DisplayPosIncidentsCount = () =>
  import('../display-pos-incidents-count/display-pos-incidents-count.vue');
const DisplayFieldScore = () => import('../display-field-score/display-field-score.vue');
const DisplayFieldBadgeLink = () =>
  import('../display-field-badge-link/display-field-badge-link.vue');
const DisplayFieldAvatar = () => import('../display-field-avatar/display-field-avatar.vue');
const DisplayFieldContactAvatar = () =>
  import('../display-field-contact-avatar/display-field-contact-avatar.vue');
const DisplayFieldColorbox = () => import('../display-field-colorbox/display-field-colorbox.vue');
const DisplayFieldButton = () => import('../display-field-button/display-field-button.vue');
const DisplayFieldCode = () => import('../display-field-code/display-field-code.vue');
const DisplayFieldDate = () => import('../display-field-date/display-field-date.vue');
const DisplayFieldWeekdayDate = () =>
  import('../display-field-weekday-date/display-field-weekday-date.vue');
const DisplayFieldBirthdate = () => import('../display-field-birthdate.vue');
const DisplayFieldDateRange = () =>
  import('../display-field-date-range/display-field-date-range.vue');
const DisplayFieldTime = () => import('../display-field-time/display-field-time.vue');
const DisplayFieldTimeRange = () =>
  import('../display-field-time-range/display-field-time-range.vue');
const DisplayFieldDays = () => import('../display-field-days/display-field-days.vue');
const DisplayFieldSwitch = () => import('../display-field-switch/display-field-switch.vue');
const DisplayFieldSelect = () => import('../display-field-select/display-field-select.vue');
const DisplayFieldFavorite = () => import('../display-field-favorite/display-field-favorite.vue');
const DisplayFieldArray = () => import('../display-field-array/display-field-array.vue');
const DisplayFieldEntityIds = () =>
  import('../display-field-entity-ids/display-field-entity-ids.vue');
const DisplayFieldDocument = () => import('../display-field-document/display-field-document.vue');
const DisplayFieldBookingEventConflicts = () =>
  import('../display-field-booking-event-conflict/display-field-booking-event-conflict.vue');

const DisplayFieldDateTime = () => import('../display-field-date-time/display-field-date-time.vue');
const DisplayFieldAmount = () => import('../display-field-amount/display-field-amount.vue');
const DisplayFieldComment = () => import('../display-field-comment/display-field-comment.vue');
const DisplayFieldPriceWithStatus = () =>
  import('../display-field-price-with-status/display-field-price-with-status.vue');
const DisplayFieldBookingEventSelect = () =>
  import('../display-field-booking-event-select/display-field-booking-event-select.vue');
const DisplayFieldDefault = () => import('../display-field-default/display-field-default.vue');
const DisplayFieldDiscountRule = () =>
  import('@shared/components/displays/display-field-discount-rule/display-field-discount-rule.vue');
const DisplayFieldRowDetails = () =>
  import('@shared/components/displays/display-field-row-details/display-field-row-details.vue');
const DisplayFieldContactRelations = () =>
  import('@shared/components/displays/display-contact-relations/display-contact-relations.vue');

const DisplaySubscriptionName = () =>
  import('@shared/components/displays/display-subscription-name.vue');

const DisplayFieldPaymentRequest = () =>
  import(
    '@shared/components/displays/display-field-payment-request/display-field-payment-request.vue'
  );

const DisplayFieldPaymentReminder = () =>
  import(
    '@shared/components/displays/display-field-payment-reminder/display-field-payment-reminder.vue'
  );

const DisplayFieldInvoiceDateBadge = () => import('../display-field-invoice-date-badge.vue');
const DisplayFieldMandate = () => import('@shared/components/displays/display-field-mandate.vue');

@Component({
  name: 'bpc-display-field',
  components: {
    'bpc-display-field-text': DisplayFieldText,
    'bpc-display-field-link': DisplayFieldLink,
    'bpc-display-contact-link': DisplayContactLink,
    'bpc-display-field-tppwb-sync': DisplayFieldTppwbSync,
    'bpc-display-field-icon': DisplayFieldIcon,
    'bpc-display-field-badge': DisplayFieldBadge,
    'bpc-display-field-score': DisplayFieldScore,
    'bpc-display-field-badge-link': DisplayFieldBadgeLink,
    'bpc-display-field-avatar': DisplayFieldAvatar,
    'bpc-display-field-contact-avatar': DisplayFieldContactAvatar,
    'bpc-display-field-colorbox': DisplayFieldColorbox,
    'bpc-display-field-button': DisplayFieldButton,
    'bpc-display-field-code': DisplayFieldCode,
    'bpc-display-field-date': DisplayFieldDate,
    'bpc-display-field-weekday-date': DisplayFieldWeekdayDate,
    'bpc-display-field-birthdate': DisplayFieldBirthdate,
    'bpc-display-field-date-range': DisplayFieldDateRange,
    'bpc-display-field-time': DisplayFieldTime,
    'bpc-display-field-time-range': DisplayFieldTimeRange,
    'bpc-display-field-days': DisplayFieldDays,
    'bpc-display-field-switch': DisplayFieldSwitch,
    'bpc-display-field-favorite': DisplayFieldFavorite,
    'bpc-display-field-array': DisplayFieldArray,
    'bpc-display-field-entity-ids': DisplayFieldEntityIds,
    'bpc-display-field-document': DisplayFieldDocument,
    'bpc-display-field-booking-event-conflict': DisplayFieldBookingEventConflicts,
    'bpc-display-field-booking-event-select': DisplayFieldBookingEventSelect,
    'bpc-display-field-date-time': DisplayFieldDateTime,
    'bpc-display-field-price': DisplayFieldPrice,
    'bpc-display-field-percent': DisplayFieldPercent,
    'bpc-display-field-amount': DisplayFieldAmount,
    'bpc-display-field-comment': DisplayFieldComment,
    'bpc-display-field-price-with-status': DisplayFieldPriceWithStatus,
    'bpc-display-field-discount-rule': DisplayFieldDiscountRule,
    'bpc-display-field-default': DisplayFieldDefault,
    'bpc-display-field-row-details': DisplayFieldRowDetails,
    'bpc-display-field-contact-relations': DisplayFieldContactRelations,
    'bpc-display-field-select': DisplayFieldSelect,
    'bpc-display-subscription-name': DisplaySubscriptionName,
    'bpc-display-pos-incidents-count': DisplayPosIncidentsCount,
    'bpc-display-field-payment-request': DisplayFieldPaymentRequest,
    'bpc-display-field-payment-reminder': DisplayFieldPaymentReminder,
    'bpc-display-field-invoice-date-badge': DisplayFieldInvoiceDateBadge,
    'bpc-display-field-mandate': DisplayFieldMandate,
  },
})
export default class DisplayField extends mixins(AbstractDisplayField) {
  entitySaved() {
    this.$emit('entity-saved');
  }
  onClick($event) {
    this.$emit('on-click', $event);
  }
}
